var map = {
	"./start1_1.png": "Ei+C",
	"./start2_1.png": "aRvf",
	"./start3_1.png": "+tsX",
	"./start4_1.png": "osYZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5mCr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/start.*_1\.png$
// module id = 5mCr
// module chunks = 1